import dayjs from 'dayjs';

export default function dateSimple(data, fuso = 3, mask = "DD/MM/YYYY") {
    if (data == null) return '---';
    if (data.length == 13) data = Number(data);
    return dayjs(data).add(fuso, 'h').format(mask)
}